<template>
    <div class="setting-wrap">
        <h1>의사(병원) 관리</h1>
        <div class="btn-group clearfix">
           <ul class="btn-radio">
               <li>
                   <input type="radio" name="doctor-set" id="doctor-set1" checked>
                   <label for="doctor-set1" class="consult-doctor-radio" @click="change_doctor()">전체</label>
               </li>
               <li>
                   <input type="radio" name="doctor-set" id="doctor-set2">
                   <label for="doctor-set2" class="consult-doctor-radio" @click="change_doctor('N')">의사</label>
               </li>
               <li>
                   <input type="radio" name="doctor-set" id="doctor-set3">
                   <label for="doctor-set3" class="consult-doctor-radio" @click="change_doctor('Y')">병원</label>
               </li>
           </ul>
        </div>
        <div class="table-list">
            <table border="0" cellpadding="0" cellspacing="0" width="100%" summary="의사 관리 리스트" class="consult-resv-list">
                <caption style="display: none;">의사 관리 리스트</caption>
                <colgroup>
                    <col width="5%">
                    <col width="10%">
                    <col width="5%">
                    <col width="*%">
                    <col width="18%">
                    <col width="15%">
                    <col width="10%">
                    <col width="7%">
                    <col width="7%">
                </colgroup>
                <thead>
                <tr>
                    <th>순번</th>
                    <th>의사이름</th>
                    <th></th>
                    <th>병원이름</th>
                    <th>email</th>
                    <th>contact</th>
                    <th>가입일</th>
                    <th>가입승인</th>
                    <th>면허증</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(dr, index) in drs" :key="index">
                    <td @click="viewDrInfo(dr)">
                        {{ dr.priority }}                    
                    </td>
                    <td @click="viewDrInfo(dr)">
                        {{ dr.dr_name }}                    
                    </td>
                    <td @click="viewDrInfo(dr)">
                        <span v-if="dr.is_hospital=='Y'" class="dr-hospital-box">
                         {{dr.is_hospital=='Y'?'병원':''}}            
                        </span>
                    </td>
                    <td @click="viewDrInfo(dr)">{{ dr.hosp_name }}</td>
                    <td @click="viewDrInfo(dr)">{{ dr.dr_email }}</td>
                    <!-- <td>{{ dr.sepcialty_name }}</td> -->
                    <td @click="viewDrInfo(dr)">{{ dr.contact }}</td>
                    <td @click="viewDrInfo(dr)">{{ dr.join_date | date_format('YYYY-MM-DD') }}</td>
                    <td>
                        <!--<input type="checkbox" :id="'consult-chk' + dr.dr_id" name="dr-status" :value="dr.status" :checked="is_confirmed(consult.status)">-->
                        <input type="checkbox" :id="'consult-chk' + dr.dr_id" name="dr-status" :checked="dr.status" @click="save_doctor(dr)">
                    </td>
                    <td>
                        <span class="dr_lic_button"><input type="button" id="dr_lic_img" name="dr_lic_img" value="면허증" @click="view_dr_lic(dr)"></span>
                    </td>
                </tr>
                </tbody>
            </table>
            <!--<div class="left-pager clearfix">
                <ul class="pager-list">
                    <li v-for="page in page_end" :class="{on: page == page_current}" @click="getDrsData(page)">{{ page }}</li>
                </ul>
                <span class="pager-next">&gt;</span>
            </div>-->
            <div class="left-pager clearfix">
                   <span class="pager-next" @click="page_current>1?getDrsData((page_current*1)-1):'#'" >&lt;</span>
                   <ul class="pager-list">
                        <li>{{page_current}}</li>
                   </ul>
                   <span id="ttt" class="pager-next" @click="is_paging?getDrsData((page_current*1)+1):'#'" disabled>&gt;</span>
               </div>
            <!-- <div class="dr-lic-box">
                <img :src="dr_lic_view" alt="" title="">
            </div> -->
        </div>

    </div>

</template>

<script>
    import { mapState } from 'vuex'
    import { nameByConstMixin } from '@/lib/mixins'
    import { STATUS_CODE } from '@/lib/constants'
  export default {
    mixins: [nameByConstMixin],
    name: 'admin',
    data () {
      return {
        tab_no: 1,
        page_begin: 1,
        page_end: 5,
        page_current: 1,
        drs: [],
        dr_lic_view: '',
        is_paging: true,     //page 처리 20190418 kjw
        is_hospital: null,   //의사,병원 여부 20200326
        chk_chosen: true
      }
    },
    computed: {
      ...mapState(['account'])
    },
    methods: {
        async change_doctor(doctor_type) {
            if(doctor_type) this.is_hospital = doctor_type;
            else this.is_hospital = null;
            this.getDrsData();
        },
        async viewDrInfo(dr, view_type) {
            //alert(dr.dr_id)
            if(dr.dr_id) this.popup_detail(dr.dr_id, view_type);
        },
        async popup_detail(dr_id, view_type) {
            let routeData = null;
            if(view_type=='profile') routeData = this.$router.resolve(`/dr_admin/dr_edit/${dr_id}`);
            else routeData = this.$router.resolve(`/dr_admin/dr_edit/${dr_id}`);

            //let popupData = await this.popupCenter(routeData.href, "dr_detail", 1000, 1000, 0, 200);

            let popupData = await this.popupCenter(routeData.href, "dr_detail", 1050, 1000, 0, 200);

            // console.log("popupData", popupData);
            //  await this.getDrsData(1);
        },
        async getDrsData (page_no = 1) {
            // console.log("this.page_no",page_no);
            // console.log("this.is_hospital", this.is_hospital);
            let params = {
                page: page_no,
                // sort: 'join_date:desc',
                is_admin: true,
                hospital_yn: this.is_hospital,
            }

            let {data: {resp}} = await this.axios.get(`doctor`, {params: params})
            
            //page 처리 20190418 kjw
            if(!resp.drs) {
                alert("마지막 페이지입니다.");
                this.is_paging = false;
                return;
            } else {
                this.drs = resp.drs
                // console.log('drs', this.drs)
                this.is_paging = true;
            }
            this.page_current = resp.page
        },
        async save_doctor (dr) {

            dr.status = !dr.status
            let post_data = {
                status: dr.status
            }

            let { data } = await this.axios.post(`doctor/${dr.dr_id}`, post_data)
            if (data.status != STATUS_CODE.OK) return alert(data.msg)

            alert('로그인 허용상태를 변경하였습니다!')
        },
        async view_dr_lic(dr) {
            // let {data: {resp}} = await this.axios.get(`doctor/${dr.dr_id}`)
            let img_detail = '';
            if(dr.license_img) img_detail = window.open(dr.license_img,"img_detail","width=800,height=800")
            //this.dr_lic_view = dr.license_img;
        }
    },
    mounted () {
      // Todo: 인증 정보에서 dr_id를 가져온다
      this.getDrsData()
      // console.log('mounted getDrsData')
    },
    watch: {

    },
    // updated() {
    //     this.$nextTick(function () {
    //         //if(this.current_consult.consult_id==null) 
    //         console.log('updated nextTick getDrsData')
    //         if(!this.chk_chosen) this.getDrsData(); // 모든 화면이 렌더링된 후 실행합니다.
    //         this.chk_chosen = false
    //     })
    // },

  }
</script>

<style scoped>
    .setting-wrap {
        width: 100%;
        padding: 30px;
        background-color: #fff;
        border: 1px solid #eee;
        box-sizing: border-box;
        text-align:left;
    }

    .setting-wrap > h1 {
        color: #494949;
        margin-bottom: 20px;
        letter-spacing: -.5px;
        font: 400 24px 'Noto Sans KR', sans-serif;
    }

    .setting-wrap > h2 {
        margin-bottom: 15px;
        font: 400 18px 'Noto Sans KR', sans-serif;
    }

    .setting-wrap > p {
        color: #b2b2b2;
        font: 400 14px 'Noto Sans KR', sans-serif;
    }

    .consult-resv-list thead {
        width: 100%;
        height: 50px;
        border-bottom: 1px solid #e7e7e9;
    }

    .consult-resv-list thead th {
        color: #b8b8b8;
        font: 500 15px/50px 'Noto Sans KR', sans-serif;
    }

    .consult-resv-list tbody tr {
        height: 50px;
        background-color: #fff;
        /*cursor: pointer;*/
        border-bottom: 1px solid #e7e7e9;
    }

    .consult-resv-list tbody tr:hover,
    .consult-resv-list tbody tr.on {
        background-color: #f5f6fa;
    }

    .consult-resv-list tbody td {
        /*text-align: center;*/
        vertical-align: middle;
        font: 400 15px 'Noto Sans KR', sans-serif;
        cursor: pointer;
    }

    .consult-resv-list tbody td:nth-of-type(2) {
        color: #b0b0b0;
    }

    /* 사용자 이름 */
    /*.consult-resv-list tbody td .user-img {*/
    /*float: left;*/
    /*margin-left: 15px;*/
    /*border-radius: 50%;*/
    /*}*/

    /*.consult-resv-list tbody td .user-name {*/
    /*float: left;*/
    /*height: 50px;*/
    /*line-height: 50px;*/
    /*margin-right: 15px;*/
    /*padding-left: 10px;*/
    /*}*/
    .consult-resv-list tbody td .user-name {
        float: left;
        text-align: left;
        overflow: hidden;
        width: 120px;
        height: 40px;
        line-height: 50px;
        margin-right: 15px;
        padding-left: 10px;
    }

    /* 확인 체크박스 */
    .consult-resv-list tbody td .consult-chk {
        width: 16px;
        height: 16px;
        margin: 0 auto;
        cursor: pointer;
        border: 1px solid #dfdfdf;
    }

    .consult-resv-list tbody td:nth-of-type(4) input[type="checkbox"] {
        display: none;
    }

    .consult-resv-list tbody td:nth-of-type(4) input[type="checkbox"]:checked + .consult-chk {
        border-color: #736ee6;
        background: url(../../assets/home/checked.png) center center/14px no-repeat;
    }

    /* 입장버튼 */
    .consult-resv-list tbody td .consult-enter {
        color: #fff;
        border: none;
        outline: 0;
        cursor: pointer;
        padding: 7px 25px;
        border-radius: 25px;
        background-color: #736ee6;
    }

    .consult-resv-list tbody td .consult-enter.consult-x {
        color: #686868;
        background-color: #ebecf4;
    }

    /* 면허증 버튼 20190411 kjw */ 
    .dr_lic_button {
        padding: 15px;
    }

    .dr_lic_button input {
        color: #777;
        border: none;
        cursor: pointer;
        padding: 5px 10px;        
    }

    .user-img-wrap {
        display: inline-block;
        float: left;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background-color: #ccc;
        font-size: 10px;
        /*display: block;*/
        border-radius: 50%;
        background-image: url('../../assets/home/profile-default.jpg');
        background-size: 100%
    }

    .user-img-wrap img {
        width: 100%
    }

    /* left pager */
    .left-pager {
        text-align:center;
        margin:20px 0;
    }

    .left-pager .pager-list,
    .left-pager .pager-next {
        display:inline-block;
    }

    .left-pager .pager-list {
        font-size: 0;
    }

    .left-pager .pager-next {
        cursor: pointer;
    }

    .left-pager .pager-list > li {
        display: inline-block;
        width: 24px;
        height: 24px;
        margin-right: 10px;
        text-align: center;
        font: 400 13px/24px 'Noto Sans KR', sans-serif;
    }

    .left-pager .pager-list > li.on {
        border: 1px solid #736ee6;
    }

    .left-pager .pager-next {
        color: #c8c9cb;
        display: inline-block;
        width: 24px;
        height: 24px;
        text-align: center;
        border: 1px solid #c8c9cb;
        font: 400 14px/24px 'Roboto', sans-serif;
    }

    .dr-lic-box {
        width: 100%;
        max-width: 700px;
        max-height: 600px;
        margin:20px auto;
        text-align: center;
        position: relative;
        border: 2px dotted #d8d8d8;
    }
    .dr-lic-box img{
        max-width:100%; 
        max-height:100%;
    }

    /* 병원 회원 표시 kjw */
    .dr-hospital-box {
        width: 100%;
        text-align: center;
        color: #b8b8b8;
        margin-left: 10px;
        padding: 3px; 
        border: 1px solid #c8c9cb;
    }

    /* 의사/병원 구분 조건 */
    .btn-group {
        width: 630px;
        margin-bottom: 10px;
        margin-right: 0px;
    }

    .btn-group .btn-radio {
        float: left;
        font-size: 0;
        margin-top: 5px;
    }

    .btn-group .btn-radio > li {
        color: #aeafb3;
        margin-right: 15px;
        display: inline-block;
    }

    .consult-doctor-radio {
        display: block;
        text-indent: 26px;
        cursor: pointer;
        position: relative;
        font: 400 12px 'Noto Sans KR', sans-serif;
    }

    .consult-doctor-radio::before {
        content: '';
        display: block;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 1px solid #ddd;
        box-sizing: border-box;
        background-color: #fff;
        position: absolute;
        left: 0;
        top: 1px;
    }

    .btn-group .btn-radio input[type="radio"] {
        display: none;
    }

    .btn-group .btn-radio input[type="radio"]:checked + .consult-doctor-radio::before {
        border: 3px solid #736ee6;
    }
</style>